import { FindingType_Numeric } from '@app/advisor-shared';
import { ModuleFE_Advisor_Expression, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable, ModuleFE_EMInterface, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { exists, filterKeys, Logger, numberInRange, sortArray, StaticLogger } from '@nu-art/ts-common';
import { ModuleFE_ProvideInfo } from '../modules/provide-info/ModuleFE_ProvideInfo.js';
import { ModuleFE_AdvisorMini } from '../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_ProvideInfo } from '@app/advisor-v5-shared';
export class ScoreData extends Logger {
    scoreReference;
    scoreVariable;
    scoreExpression;
    static createNew = (scoreReference) => {
        const scoreVariable = ModuleFE_Advisor_Variable.cache.unique(scoreReference.variableId);
        if (!scoreVariable) {
            StaticLogger.logError(`Could not get score variable for id ${scoreReference.variableId}`);
            return;
        }
        return new ScoreData(scoreReference, scoreVariable);
    };
    constructor(scoreReference, scoreVariable) {
        super(`ScoreData[${scoreVariable.name}]`);
        this.scoreReference = scoreReference;
        this.scoreVariable = scoreVariable;
        this.scoreExpression = ModuleFE_Advisor_Expression.cache.find(exp => exp.associatedVar === this.scoreVariable._id);
    }
    //######################### Internal Logic #########################
    getLatestFinding = () => {
        const findings = ModuleFE_RuntimeFinding.cache.filter(f => !f.isGeneratedVariable
            && !f.isPartialCalculation
            && f.type === FindingType_Numeric
            && f.variableId === this.scoreVariable._id);
        sortArray(findings, f => f.issuedTimestamp, true);
        return findings[0];
    };
    getPartialCalculationFinding = () => {
        const findings = ModuleFE_RuntimeFinding.cache.filter(f => !!f.isPartialCalculation
            && f.type === FindingType_Numeric
            && f.variableId === this.scoreVariable._id);
        sortArray(findings, f => f.issuedTimestamp, true);
        return findings[0];
    };
    // private toastUnsupportedInMini = () => {
    // 	ModuleFE_Toaster.toastInfo('Viewing scores is currently available in full mode only');
    // };
    //######################### Public Logic #########################
    getScoreReference = () => this.scoreReference;
    getLabel = () => {
        return this.scoreVariable.name;
    };
    getValue = () => {
        const latestFinding = this.getLatestFinding();
        if (!latestFinding || !exists(latestFinding.value))
            return;
        return Math.round(latestFinding.value * 10) / 10;
    };
    getPartialValue = () => {
        const latestFinding = this.getPartialCalculationFinding();
        if (!latestFinding || !exists(latestFinding.value))
            return;
        return Math.round(latestFinding.value * 10) / 10;
    };
    getSeverity = () => {
        if (!this.scoreExpression?.severityDeclarations)
            return;
        const value = this.getValue();
        if (!value)
            return;
        for (const declaration of this.scoreExpression.severityDeclarations) {
            const rangeValue = ModuleFE_Advisor_Value.cache.unique(declaration.severityValue);
            if (!rangeValue)
                continue;
            if (numberInRange(value, rangeValue.data.scope))
                return declaration;
        }
    };
    openScoreEdit = async () => {
        if (!this.scoreExpression) {
            StaticLogger.logError(`Can't dispatch score to edit, score is not connected to an expression`);
            return;
        }
        // if (ModuleFE_AdvisorMini.getIsMiniActive())
        // 	return this.toastUnsupportedInMini();
        try {
            const latestFinding = this.getLatestFinding();
            const neededVars = await ModuleFE_EMInterface.vv1.calculator.getExpressionNeededVariables({
                expressionIds: [this.scoreExpression._id],
            }).executeSync();
            const neededVariables = filterKeys({
                ...neededVars.neededVariables[0],
                findingId: latestFinding?._id
            });
            ModuleFE_ProvideInfo.score.open(this.scoreExpression._id, neededVariables, true);
            if (ModuleFE_AdvisorMini.getIsMiniActive())
                ModuleFE_AdvisorMini.openPanel(PanelKey_ProvideInfo);
        }
        catch (err) {
            StaticLogger.logError('Failed to open score to edit', err);
        }
    };
}
//# sourceMappingURL=ScoreData.js.map